import React from 'react';
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";
import InputCheckbox from "../../../../../../components/input/input-checkbox.jsx";
import optionsUtils from "../../../../../../utils/options-utils.js";
import {getCities, getNeighborhoods, getStreets} from "../../../../../../utils/location-utils.js";
import {MaskDefault} from "../../../../../../utils/mask.js";

const AddressesFilter = ({filter, onChange, onChangeCustom}) => {
    return (
        <SentryRow>
            <div className="col-span-12">
                <InputCheckbox
                    id="isHomeless"
                    label="Situação de rua"
                    checked={!!filter.isHomeless}
                    onChange={(e) => onChangeCustom(e.target.checked, "isHomeless")}
                />
            </div>
            <div className="col-span-12">
                <SelectComponent
                    id="address"
                    loadOptions={getStreets}
                    value={optionsUtils.getValue(filter.address)}
                    isAsync={true}
                    label="Logradouro"
                    onChange={(selected) => onChangeCustom(selected?.value ?? "", "address")}
                    cacheOptions
                    defaultOptions={[]}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="neighborhood"
                    loadOptions={getNeighborhoods}
                    value={optionsUtils.getValue(filter.neighborhood)}
                    isAsync={true}
                    label="Bairro"
                    onChange={(selected) => onChangeCustom(selected?.value ?? "", "neighborhood")}
                    cacheOptions
                    defaultOptions={[]}
                />
            </div>
            <div className="col-span-6">
                <SelectComponent
                    id="city"
                    loadOptions={getCities}
                    value={optionsUtils.getValue(filter.city)}
                    isAsync={true}
                    label="Município"
                    onChange={(selected) => onChangeCustom(selected?.value ?? "", "city")}
                    cacheOptions
                    defaultOptions={[]}
                />
            </div>
            <div className="col-span-8">
                <InputForm
                    id="complement"
                    value={filter.complement}
                    label="Complemento"
                    onChange={onChange}
                />
            </div>
            <div className="col-span-4">
                <InputForm
                    id="zipCode"
                    value={filter.zipCode}
                    onChange={onChange}
                    label="CEP"
                    mask={MaskDefault.cep}
                />
            </div>
        </SentryRow>
    );
};

export default AddressesFilter;
